import CategoryNode from './categoryNode';

export default CategoryNode;
